"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CustomRichTextField = props => {
  var rawHtml = props.field.model.html,
    shouldHide;
  var field = props.field,
    state = _conditionalRendering.store.getState();
  var conditionId = field.model.conditionSettings.fieldKey;
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
  }
  (0, _react.useEffect)(() => {
    var popbuttons = document.querySelectorAll('#poppin');
    popbuttons === null || popbuttons === void 0 || popbuttons.forEach(function (e, i) {
      e.id = 'rtpopperbtn' + i;
      var kernals = e.querySelector('#popcorn');
      kernals.id = 'popperkernal' + i;
      var ttip = e.querySelector('#tooltip');
      var popperInstance = Popper.createPopper(kernals, ttip, {
        placement: 'top',
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }]
      });
      ttip.classList.add('toggle-tooltip');
      popperInstance.update();
    });

    // popover for all tooltip
    popbuttons === null || popbuttons === void 0 || popbuttons.forEach(function (e, i) {
      document.addEventListener('click', function (event) {
        var curId = event.target.id;
        var clickButton = e.contains(document.getElementById(curId));
        var ttip = e.querySelector('#tooltip');
        if (!clickButton) {
          if (ttip) ttip.classList.add('toggle-tooltip');
        } else {
          if (ttip.classList.contains('toggle-tooltip')) {
            ttip.classList.remove('toggle-tooltip');
          } else ttip.classList.add('toggle-tooltip');
        }
      });
    });
  }, []);
  if (shouldHide) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: rawHtml
      }
    });
  }
};
var _default = exports.default = CustomRichTextField;